import { Button } from '@/components/ui/button';
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetFooter,
} from '@/components/ui/sheet';
import { ScrollArea } from '@/components/ui/scroll-area';
import { X } from 'lucide-react';
import {
  CONTENT_CATEGORY_LABELS,
  SUITABLE_GRADE_LABELS,
  type ContentCategory,
  type SuitableGrade,
} from '@shared/api.interface';

interface MobileFilterDrawerProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  category: ContentCategory | '';
  grade: SuitableGrade | '';
  resultCount: number;
  onCategoryChange: (value: ContentCategory | '') => void;
  onGradeChange: (value: SuitableGrade | '') => void;
  onReset: () => void;
  onConfirm: () => void;
}

export function MobileFilterDrawer({
  open,
  onOpenChange,
  category,
  grade,
  resultCount,
  onCategoryChange,
  onGradeChange,
  onReset,
  onConfirm,
}: MobileFilterDrawerProps) {
  const hasFilters = category || grade;

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="bottom" className="h-[85vh] p-0 flex flex-col">
        <SheetHeader className="px-4 py-3 border-b">
          <SheetTitle className="text-base">筛选</SheetTitle>
        </SheetHeader>

        <ScrollArea className="flex-1 px-4 py-4">
          <div className="space-y-6">
            {/* 内容分类 */}
            <div>
              <h4 className="text-sm font-medium text-foreground mb-3">
                内容分类
              </h4>
              <div className="grid grid-cols-3 gap-2">
                <Button
                  variant={category === '' ? 'default' : 'outline'}
                  size="sm"
                  onClick={() => onCategoryChange('')}
                  className="w-full text-xs"
                >
                  全部
                </Button>
                {Object.entries(CONTENT_CATEGORY_LABELS).map(([key, label]) => (
                  <Button
                    key={key}
                    variant={category === key ? 'default' : 'outline'}
                    size="sm"
                    onClick={() => onCategoryChange(key as ContentCategory)}
                    className="w-full text-xs"
                  >
                    {label}
                  </Button>
                ))}
              </div>
            </div>

            {/* 适合年级 */}
            <div>
              <h4 className="text-sm font-medium text-foreground mb-3">
                适合年级
              </h4>
              <div className="flex flex-col gap-2">
                <Button
                  variant={grade === '' ? 'default' : 'outline'}
                  size="sm"
                  onClick={() => onGradeChange('')}
                  className="w-full justify-start text-xs"
                >
                  全部年级
                </Button>
                <Button
                  variant={grade === 'low' ? 'default' : 'outline'}
                  size="sm"
                  onClick={() => onGradeChange('low')}
                  className="w-full justify-start text-xs"
                >
                  {SUITABLE_GRADE_LABELS.low}
                </Button>
                <Button
                  variant={grade === 'high' ? 'default' : 'outline'}
                  size="sm"
                  onClick={() => onGradeChange('high')}
                  className="w-full justify-start text-xs"
                >
                  {SUITABLE_GRADE_LABELS.high}
                </Button>
              </div>
            </div>
          </div>
        </ScrollArea>

        <SheetFooter className="px-4 py-3 border-t flex-row gap-2">
          <Button
            variant="outline"
            onClick={onReset}
            disabled={!hasFilters}
            className="flex-1"
          >
            <X className="h-4 w-4 mr-1" />
            重置
          </Button>
          <Button onClick={onConfirm} className="flex-1">
            查看结果{resultCount > 0 ? `(${resultCount})` : ''}
          </Button>
        </SheetFooter>
      </SheetContent>
    </Sheet>
  );
}
